"use strict";

var _objectSpread = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
var _toConsumableArray = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");
var _asyncToGenerator = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");
var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");
var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");
var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isTextSearchAdapter = exports.isRefNameAliasAdapter = exports.isFeatureAdapter = exports.isRegionsAdapter = exports.isSequenceAdapter = exports.BaseSequenceAdapter = exports.BaseFeatureDataAdapter = exports.BaseAdapter = void 0;
var rxjs_1 = require("rxjs");
var operators_1 = require("rxjs/operators");
var mobx_state_tree_1 = require("mobx-state-tree");
// locals
var rxjs_2 = require("../util/rxjs");
var util_1 = require("../util");
var configuration_1 = require("../configuration");
var stats_1 = require("../util/stats");
var idMaker_1 = __importDefault(require("../util/idMaker"));
var EmptyConfig = (0, configuration_1.ConfigurationSchema)('empty', {});
var BaseAdapter = /*#__PURE__*/function () {
  function BaseAdapter() {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : EmptyConfig.create();
    var getSubAdapter = arguments.length > 1 ? arguments[1] : undefined;
    var pluginManager = arguments.length > 2 ? arguments[2] : undefined;
    _classCallCheck(this, BaseAdapter);
    this.config = config;
    this.getSubAdapter = getSubAdapter;
    this.pluginManager = pluginManager;
    // note: we use switch on jest here for more simple feature IDs
    // in test environment
    if (typeof jest === 'undefined') {
      var data = (0, mobx_state_tree_1.isStateTreeNode)(config) ? (0, mobx_state_tree_1.getSnapshot)(config) : config;
      this.id = "".concat((0, idMaker_1.default)(data));
    } else {
      this.id = 'test';
    }
  }
  _createClass(BaseAdapter, [{
    key: "getConf",
    value: function getConf(arg) {
      return (0, configuration_1.readConfObject)(this.config, arg);
    }
  }]);
  return BaseAdapter;
}();
exports.BaseAdapter = BaseAdapter;
BaseAdapter.capabilities = [];
/**
 * Base class for feature adapters to extend. Defines some methods that
 * subclasses must implement.
 */
var BaseFeatureDataAdapter = /*#__PURE__*/function (_BaseAdapter) {
  _inherits(BaseFeatureDataAdapter, _BaseAdapter);
  function BaseFeatureDataAdapter() {
    _classCallCheck(this, BaseFeatureDataAdapter);
    return _possibleConstructorReturn(this, _getPrototypeOf(BaseFeatureDataAdapter).apply(this, arguments));
  }
  _createClass(BaseFeatureDataAdapter, [{
    key: "getHeader",
    // public abstract getFeatures(
    //   region: Region,
    //   opts: BaseOptions,
    // ): Observable<Feature> {
    //   return ObservableCreate(observer => {
    //     const records = getRecords(assembly, refName, start, end)
    //     records.forEach(record => {
    //       observer.next(this.recordToFeature(record))
    //     })
    //     observer.complete()
    //   })
    // }
    /**
     * Return "header info" that is fetched from the data file, or other info
     * that would not simply be in the config of the file. The return value can
     * be `{tag:string, data: any}[]` e.g. list of tags with their values which
     * is how VCF,BAM,CRAM return values for getInfo or it can be a nested JSON
     * object
     */
    value: function () {
      var _getHeader = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_opts) {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", null);
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function getHeader(_x) {
        return _getHeader.apply(this, arguments);
      }
      return getHeader;
    }()
    /**
     * Return info that is primarily used for interpreting the data that is there,
     * primarily in reference to being used for augmenting feature details panels
     */
  }, {
    key: "getMetadata",
    value: function () {
      var _getMetadata = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(_opts) {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", null);
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      function getMetadata(_x2) {
        return _getMetadata.apply(this, arguments);
      }
      return getMetadata;
    }()
    /**
     * Checks if the store has data for the given assembly and reference
     * sequence, and then gets the features in the region if it does.
     */
  }, {
    key: "getFeaturesInRegion",
    value: function getFeaturesInRegion(region) {
      var _this = this;
      var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return (0, rxjs_2.ObservableCreate)( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(observer) {
          var hasData;
          return _regeneratorRuntime().wrap(function _callee3$(_context3) {
            while (1) switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this.hasDataForRefName(region.refName, opts);
              case 2:
                hasData = _context3.sent;
                (0, util_1.checkAbortSignal)(opts.signal);
                if (!hasData) {
                  observer.complete();
                } else {
                  _this.getFeatures(region, opts).subscribe(observer);
                }
              case 5:
              case "end":
                return _context3.stop();
            }
          }, _callee3);
        }));
        return function (_x3) {
          return _ref.apply(this, arguments);
        };
      }());
    }
    /**
     * Checks if the store has data for the given assembly and reference
     * sequence, and then gets the features in the region if it does.
     *
     * Currently this just calls getFeatureInRegion for each region. Adapters
     * that are frequently called on multiple regions simultaneously may
     * want to implement a more efficient custom version of this method.
     *
     * Currently this just calls getFeatureInRegion for each region. Adapters that
     * are frequently called on multiple regions simultaneously may want to
     * implement a more efficient custom version of this method.
     *
     * @param regions - Regions
     * @param opts - Feature adapter options
     * @returns Observable of Feature objects in the regions
     */
  }, {
    key: "getFeaturesInMultipleRegions",
    value: function getFeaturesInMultipleRegions(regions) {
      var _this2 = this;
      var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return (0, rxjs_1.merge).apply(void 0, _toConsumableArray(regions.map(function (region) {
        return _this2.getFeaturesInRegion(region, opts);
      })));
    }
    /**
     * Check if the store has data for the given reference name.
     * @param refName - Name of the reference sequence
     * @returns Whether data source has data for the given reference name
     */
  }, {
    key: "hasDataForRefName",
    value: function () {
      var _hasDataForRefName = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(refName) {
        var opts,
          refNames,
          _args4 = arguments;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              opts = _args4.length > 1 && _args4[1] !== undefined ? _args4[1] : {};
              _context4.next = 3;
              return this.getRefNames(opts);
            case 3:
              refNames = _context4.sent;
              return _context4.abrupt("return", refNames.includes(refName));
            case 5:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function hasDataForRefName(_x4) {
        return _hasDataForRefName.apply(this, arguments);
      }
      return hasDataForRefName;
    }()
  }, {
    key: "getRegionStats",
    value: function () {
      var _getRegionStats = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(region, opts) {
        var feats;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              feats = this.getFeatures(region, opts);
              return _context5.abrupt("return", (0, stats_1.scoresToStats)(region, feats));
            case 2:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function getRegionStats(_x5, _x6) {
        return _getRegionStats.apply(this, arguments);
      }
      return getRegionStats;
    }()
  }, {
    key: "getMultiRegionStats",
    value: function () {
      var _getMultiRegionStats = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var _this3 = this;
        var regions,
          opts,
          feats,
          scoreMax,
          scoreMin,
          scoreSum,
          scoreSumSquares,
          featureCount,
          basesCovered,
          _args6 = arguments;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              regions = _args6.length > 0 && _args6[0] !== undefined ? _args6[0] : [];
              opts = _args6.length > 1 ? _args6[1] : undefined;
              if (regions.length) {
                _context6.next = 4;
                break;
              }
              return _context6.abrupt("return", (0, stats_1.blankStats)());
            case 4:
              _context6.next = 6;
              return Promise.all(regions.map(function (region) {
                return _this3.getRegionStats(region, opts);
              }));
            case 6:
              feats = _context6.sent;
              scoreMax = (0, util_1.max)(feats.map(function (a) {
                return a.scoreMax;
              }));
              scoreMin = (0, util_1.min)(feats.map(function (a) {
                return a.scoreMin;
              }));
              scoreSum = (0, util_1.sum)(feats.map(function (a) {
                return a.scoreSum;
              }));
              scoreSumSquares = (0, util_1.sum)(feats.map(function (a) {
                return a.scoreSumSquares;
              }));
              featureCount = (0, util_1.sum)(feats.map(function (a) {
                return a.featureCount;
              }));
              basesCovered = (0, util_1.sum)(feats.map(function (a) {
                return a.basesCovered;
              }));
              return _context6.abrupt("return", (0, stats_1.rectifyStats)({
                scoreMin: scoreMin,
                scoreMax: scoreMax,
                featureCount: featureCount,
                basesCovered: basesCovered,
                scoreSumSquares: scoreSumSquares,
                scoreSum: scoreSum
              }));
            case 14:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }));
      function getMultiRegionStats() {
        return _getMultiRegionStats.apply(this, arguments);
      }
      return getMultiRegionStats;
    }()
  }, {
    key: "estimateRegionsStats",
    value: function () {
      var _estimateRegionsStats = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9(regions, opts) {
        var _this4 = this;
        var region, lastTime, statsFromInterval, maybeRecordStats;
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              if (regions.length) {
                _context9.next = 2;
                break;
              }
              throw new Error('No regions to estimate stats for');
            case 2:
              region = regions[0];
              lastTime = +Date.now();
              statsFromInterval = /*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(length, expansionTime) {
                  var start, end, sampleCenter, query, features;
                  return _regeneratorRuntime().wrap(function _callee7$(_context7) {
                    while (1) switch (_context7.prev = _context7.next) {
                      case 0:
                        start = region.start, end = region.end;
                        sampleCenter = start * 0.75 + end * 0.25;
                        query = _objectSpread({}, region, {
                          start: Math.max(0, Math.round(sampleCenter - length / 2)),
                          end: Math.min(Math.round(sampleCenter + length / 2), end)
                        });
                        _context7.next = 5;
                        return (0, rxjs_1.firstValueFrom)(_this4.getFeatures(query, opts).pipe((0, operators_1.toArray)()));
                      case 5:
                        features = _context7.sent;
                        return _context7.abrupt("return", maybeRecordStats(length, {
                          featureDensity: features.length / length
                        }, features.length, expansionTime));
                      case 7:
                      case "end":
                        return _context7.stop();
                    }
                  }, _callee7);
                }));
                return function statsFromInterval(_x9, _x10) {
                  return _ref2.apply(this, arguments);
                };
              }();
              maybeRecordStats = /*#__PURE__*/function () {
                var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8(interval, stats, statsSampleFeatures, expansionTime) {
                  var refLen, currTime;
                  return _regeneratorRuntime().wrap(function _callee8$(_context8) {
                    while (1) switch (_context8.prev = _context8.next) {
                      case 0:
                        refLen = region.end - region.start;
                        if (!(statsSampleFeatures >= 70 || interval * 2 > refLen)) {
                          _context8.next = 5;
                          break;
                        }
                        return _context8.abrupt("return", stats);
                      case 5:
                        if (!(expansionTime <= 5000)) {
                          _context8.next = 12;
                          break;
                        }
                        currTime = +Date.now();
                        expansionTime += currTime - lastTime;
                        lastTime = currTime;
                        return _context8.abrupt("return", statsFromInterval(interval * 2, expansionTime));
                      case 12:
                        console.warn("Stats estimation reached timeout, or didn't get enough features");
                        return _context8.abrupt("return", {
                          featureDensity: Infinity
                        });
                      case 14:
                      case "end":
                        return _context8.stop();
                    }
                  }, _callee8);
                }));
                return function maybeRecordStats(_x11, _x12, _x13, _x14) {
                  return _ref3.apply(this, arguments);
                };
              }();
              return _context9.abrupt("return", statsFromInterval(1000, 0));
            case 7:
            case "end":
              return _context9.stop();
          }
        }, _callee9);
      }));
      function estimateRegionsStats(_x7, _x8) {
        return _estimateRegionsStats.apply(this, arguments);
      }
      return estimateRegionsStats;
    }()
  }]);
  return BaseFeatureDataAdapter;
}(BaseAdapter);
exports.BaseFeatureDataAdapter = BaseFeatureDataAdapter;
var BaseSequenceAdapter = /*#__PURE__*/function (_BaseFeatureDataAdapt) {
  _inherits(BaseSequenceAdapter, _BaseFeatureDataAdapt);
  function BaseSequenceAdapter() {
    _classCallCheck(this, BaseSequenceAdapter);
    return _possibleConstructorReturn(this, _getPrototypeOf(BaseSequenceAdapter).apply(this, arguments));
  }
  _createClass(BaseSequenceAdapter, [{
    key: "estimateRegionsStats",
    value: function () {
      var _estimateRegionsStats2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              return _context10.abrupt("return", {
                featureDensity: 0
              });
            case 1:
            case "end":
              return _context10.stop();
          }
        }, _callee10);
      }));
      function estimateRegionsStats() {
        return _estimateRegionsStats2.apply(this, arguments);
      }
      return estimateRegionsStats;
    }()
  }]);
  return BaseSequenceAdapter;
}(BaseFeatureDataAdapter);
exports.BaseSequenceAdapter = BaseSequenceAdapter;
function isSequenceAdapter(thing) {
  return 'getRegions' in thing && 'getFeatures' in thing;
}
exports.isSequenceAdapter = isSequenceAdapter;
function isRegionsAdapter(thing) {
  return 'getRegions' in thing;
}
exports.isRegionsAdapter = isRegionsAdapter;
function isFeatureAdapter(thing) {
  return 'getFeatures' in thing;
}
exports.isFeatureAdapter = isFeatureAdapter;
function isRefNameAliasAdapter(thing) {
  return 'getRefNameAliases' in thing;
}
exports.isRefNameAliasAdapter = isRefNameAliasAdapter;
function isTextSearchAdapter(thing) {
  return 'searchIndex' in thing;
}
exports.isTextSearchAdapter = isTextSearchAdapter;